import React from 'react'

import {Colors} from '../../../src/components/UI/index.js'
import {buttonResetStyle} from '../../../src/components/UI/buttons/index.js'
import {focusableClass, ensureFocusStyles} from '../../../src/components/UI/styles.js'

ensureFocusStyles()

/**
 * An icon with a label in the TopBar (the back button), in the bar's font. Not a Button: that has a smaller icon and
 * its own font, and this one keeps the look of the bar. A <button>, so it gets the keyboard and the focus ring.
 */
export default function TopBarButton({style = {}, label, icon, onClick}) {
    const defaultStyle = {
        ...buttonResetStyle,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: Colors.buttonSolid,
        cursor: 'pointer',
        width: 'auto',
        height: '100%',
        ...style
    }

    return (
        <button type='button' className={focusableClass} style={defaultStyle} onClick={onClick}>
            <i aria-hidden style={{fontSize: 20, marginRight: 10}} className={icon} />
            {label}
        </button>
    )
}
